module.exports = __webpack_public_path__ + "static/forecast/weather/nightthunderstorm-2d9738891be623fe0ccd6cf728633214.svg";